export function toGenitive(name: string): string {
  if (!name) return name;
  const last = name[name.length - 1].toLowerCase();
  const preLast = name.length > 1 ? name[name.length - 2].toLowerCase() : "";

  if (last === "а") {
    if ("гкхжшщч".includes(preLast)) return name.slice(0, -1) + "и";
    return name.slice(0, -1) + "ы";
  }
  if (last === "я") return name.slice(0, -1) + "и";
  if (last === "й") return name.slice(0, -1) + "я";
  if (last === "ь") return name.slice(0, -1) + "я";
  // consonant — add а
  return name + "а";
}

// Винительный падеж (кого? Ваню, Машу, Тима)
export function toAccusative(name: string): string {
  if (!name) return name;
  const last = name[name.length - 1].toLowerCase();

  if (last === "а") return name.slice(0, -1) + "у";
  if (last === "я") return name.slice(0, -1) + "ю";
  if (last === "й") return name.slice(0, -1) + "я";
  if (last === "ь") return name.slice(0, -1) + "я";
  // consonant (male names) — add а
  return name + "а";
}
